export default function numbers() {
    const section = document.querySelector(".numbers"); // ajuste essa classe conforme seu HTML

    if (section) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateNumbers();
                    observer.unobserve(section);
                }
            });
        }, {
            threshold: 0.5,
        });

        observer.observe(section);
    }

    function animateNumbers() {
        const elements = document.querySelectorAll(".increment");

        elements.forEach((element) => {
            const finalValue = parseInt(element.getAttribute("data-number"));
            const duration = 2000;

            let startTime = null;

            function animate(currentTime) {
                if (!startTime) startTime = currentTime;

                const progress = currentTime - startTime;
                const percentage = Math.min(progress / duration, 1);

                const current = Math.floor(finalValue * percentage);
                element.textContent = current;

                if (percentage < 1) {
                    requestAnimationFrame(animate);
                } else {
                    element.textContent = finalValue;
                }
            }

            requestAnimationFrame(animate);
        });
    }
}
